import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableContainer,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch
} from 'carbon-components-react';
import { toLocalDateTimeFormat } from 'utilities/helper.util';
import { Button } from 'carbon-components-react';
import { useDispatch } from 'react-redux';
import { setAdminUserModelOpenStart } from 'redux/organisation/action';
import { OrganisationUser } from 'redux/organisation/types';
import { Header } from 'redux/member/types';
import { Add16 } from '@carbon/icons-react';
import DisplayUserRow from './DisplayUsersRow';
import { selectIsModalOpen } from 'redux/organisation';
import { currentUser } from 'redux/session/selectors';

const DisplayUsers: React.FC<any> = ({ organisationUsers }) => {
  const dispatch: any = useDispatch();
  const handleClick = () => dispatch(setAdminUserModelOpenStart(true));
  const [searchBy, updateSearchBy] = useState('');
  const handleChangeSearchBy = (e: any) =>
    updateSearchBy(e.target.value.toUpperCase());

  const isModalOpen = useSelector(selectIsModalOpen);

  const {
    Organisation: { role: orgRole }
  } = useSelector(currentUser);

  const headers: Array<Header> =
    orgRole === 'ASSETOWNER'
      ? [
          {
            key: 'name',
            header: 'Name',
            isSortable: true
          },
          { key: 'role', header: 'Role', isSortable: true },
          { key: 'emailAddress', header: 'Email address', isSortable: true },
          { key: 'lastLoggedInAt', header: 'Last signed in', isSortable: true }
        ]
      : [
          {
            key: 'name',
            header: 'Name',
            isSortable: true
          },
          { key: 'emailAddress', header: 'Email address', isSortable: true },
          { key: 'lastLoggedInAt', header: 'Last signed in', isSortable: true }
        ];

  const translateRole = (role: string) => {
    switch (role) {
      case 'AOADMIN':
        return 'Administrator';
      case 'AOVIEWER':
        return 'Viewer';
      default:
        return role;
    }
  };

  if (searchBy?.length > 2)
    organisationUsers = organisationUsers.filter(
      (user: OrganisationUser) =>
        user.firstName?.toUpperCase().includes(searchBy) ||
        user.emailAddress?.toUpperCase().includes(searchBy)
    );
  const filteredUsers = organisationUsers?.map((user: OrganisationUser) => ({
    id: user.id?.toString(),
    firstName: user.firstName,
    name: `${user.firstName} ${user.lastName}`,
    role: user.role ? translateRole(user.role) : '',
    emailAddress: user.emailAddress,
    lastLoggedInAt: user.lastLoggedInAt
      ? toLocalDateTimeFormat(user.lastLoggedInAt)
      : 'Never'
  }));

  return (
    <DataTable rows={filteredUsers} headers={headers} isSortable={true}>
      {({ rows, headers, getTableProps, getHeaderProps, getRowProps }: any) => {
        return (
          <TableContainer>
            <TableToolbar>
              <TableToolbarContent>
                <TableToolbarSearch
                  onChange={handleChangeSearchBy}
                  tabIndex={isModalOpen ? -1 : 0}
                />
                <Button
                  onClick={handleClick}
                  renderIcon={Add16}
                  iconDescription={`Add ${
                    orgRole === 'ASSETOWNER' ? 'user' : 'administrator'
                  }`}
                >
                  Add {orgRole === 'ASSETOWNER' ? 'user' : 'administrator'}
                </Button>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header: any) => (
                    <TableHeader
                      key={header.key}
                      {...getHeaderProps({
                        header
                      })}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                  <TableHeader></TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row: any, index: any) => (
                  <DisplayUserRow
                    row={row}
                    getRowProps={getRowProps}
                    key={index}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      }}
    </DataTable>
  );
};
DisplayUsers.displayName = 'DisplayUsers';
export default DisplayUsers;
